export default __webpack_public_path__ + "static/media/ic_tab_profile.a6c43ce8.svg";